module.exports = __webpack_public_path__ + "static/img/dorm-warn-active.45644ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu/dorm-warn-active.png
// module id = y2su
// module chunks = 58